import { render } from "./Reserve.vue?vue&type=template&id=51dfc4e4&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"

import "./Reserve.vue?vue&type=style&index=0&id=51dfc4e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dfc4e4"]])

export default __exports__